
const terminalSettingsUtils = require('./terminalSettingsUtils');
const stringUtil = require('../../string/stringUtil');

module.exports.getCliNotificationPosition = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getDisplaySettings().cliNotificationPosition))
        return null;

    return terminalSettingsUtils.getDisplaySettings().cliNotificationPosition;
}

module.exports.setCliNotificationPosition = function(cliNotificationPosition)
{
    terminalSettingsUtils.getDisplaySettings().cliNotificationPosition = cliNotificationPosition;
    terminalSettingsUtils.saveSettings();
}

module.exports.getOrderScreenLayout = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getDisplaySettings().orderScreenLayout))
        return "Classic";

    return terminalSettingsUtils.getDisplaySettings().orderScreenLayout;
}

module.exports.setOrderScreenLayout = function(orderScreenLayout)
{
    terminalSettingsUtils.getDisplaySettings().orderScreenLayout = orderScreenLayout;
    terminalSettingsUtils.saveSettings();
}

module.exports.getMenuItemLayout = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getDisplaySettings().menuItemLayout))
        return "LayoutWithImages";

    return terminalSettingsUtils.getDisplaySettings().menuItemLayout;
}

module.exports.setMenuItemLayout = function(menuItemLayout)
{
    terminalSettingsUtils.getDisplaySettings().menuItemLayout = menuItemLayout;
    terminalSettingsUtils.saveSettings();
}


module.exports.getModifierLayout = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getDisplaySettings().modifierLayout))
        return "LayoutWithWizard";

    return terminalSettingsUtils.getDisplaySettings().modifierLayout;
}

module.exports.setModifierLayout = function(modifierLayout)
{
    terminalSettingsUtils.getDisplaySettings().modifierLayout = modifierLayout;
    terminalSettingsUtils.saveSettings();
}

module.exports.getDisplayInternalNotes = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getDisplaySettings().displayInternalNotes))
        return true;

    return terminalSettingsUtils.getDisplaySettings().displayInternalNotes;
}

module.exports.setDisplayInternalNotes = function(displayInternalNotes)
{
    terminalSettingsUtils.getDisplaySettings().displayInternalNotes = displayInternalNotes == true;
    terminalSettingsUtils.saveSettings();
}

module.exports.getDisplayStorefrontSelection = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getDisplaySettings().displayStorefrontSelection))
        return true;

    return terminalSettingsUtils.getDisplaySettings().displayStorefrontSelection;
}

module.exports.setDisplayStorefrontSelection = function(displayStorefrontSelection)
{
    terminalSettingsUtils.getDisplaySettings().displayStorefrontSelection = displayStorefrontSelection == true;
    terminalSettingsUtils.saveSettings();
}

module.exports.getDisplayLoginStaffName = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getDisplaySettings().displayLoginStaffName))
        return false;

    return terminalSettingsUtils.getDisplaySettings().displayLoginStaffName;
}

module.exports.setDisplayLoginStaffName = function(displayLoginStaffName)
{
    terminalSettingsUtils.getDisplaySettings().displayLoginStaffName = displayLoginStaffName == true;
    terminalSettingsUtils.saveSettings();
}

module.exports.getDisplayOnScreenKeyboard = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getDisplaySettings().displayOnScreenKeyboard))
        return true;

    return terminalSettingsUtils.getDisplaySettings().displayOnScreenKeyboard;
}

module.exports.setDisplayOnScreenKeyboard = function(displayOnScreenKeyboard)
{
    terminalSettingsUtils.getDisplaySettings().displayOnScreenKeyboard = displayOnScreenKeyboard == true;
    terminalSettingsUtils.saveSettings();
}

module.exports.getDisplayLayoutTheme = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getDisplaySettings().layoutThemeJson))
        return null;

    return JSON.parse(terminalSettingsUtils.getDisplaySettings().layoutThemeJson);
}

module.exports.setDisplayLayoutTheme = function(layoutTheme)
{
    let layoutThemeJson = null;
    if (layoutTheme != null)
        layoutThemeJson = JSON.stringify(layoutTheme);

    terminalSettingsUtils.getDisplaySettings().layoutThemeJson = layoutThemeJson;
    terminalSettingsUtils.saveSettings();
}

module.exports.getDisplayScreenSaver = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getDisplaySettings().displayScreenSaver))
        return true;

    return terminalSettingsUtils.getDisplaySettings().displayScreenSaver;
}

module.exports.setDisplayScreenSaver = function(displayScreenSaver)
{
    terminalSettingsUtils.getDisplaySettings().displayScreenSaver = displayScreenSaver == true;
    terminalSettingsUtils.saveSettings();
}